import { render } from "./BulkChangeCategoryModal.vue?vue&type=template&id=47eb0b9e&scoped=true"
import script from "./BulkChangeCategoryModal.vue?vue&type=script&lang=js"
export * from "./BulkChangeCategoryModal.vue?vue&type=script&lang=js"

import "./BulkChangeCategoryModal.vue?vue&type=style&index=0&id=47eb0b9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47eb0b9e"]])

export default __exports__